import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#E5E3DB] bg-[#F0EFEA]/50" data-testid="site-footer">
      <div className="mds-container py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <Link to="/" className="inline-flex items-center gap-3 mb-4" aria-label="Matt's Daily Savers home">
              <img src="/logo.webp" alt="Matt's Daily Savers" className="h-16 w-16" width="64" height="64" />
              <span className="sr-only">Matt's Daily Savers</span>
            </Link>
            <p className="text-[#4A5D54] max-w-md leading-relaxed">
              Honest, hands-on reviews of the UK's best cashback sites, reward apps,
              card tools and survey panels — from someone who actually uses them.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-[#4A5D54]">
              <li><a href="/directory" className="mds-link" data-testid="footer-link-directory">Directory</a></li>
              <li><a href="/showcase" className="mds-link" data-testid="footer-link-showcase">How I Save £220/mo</a></li>
              <li><a href="/blog" className="mds-link" data-testid="footer-link-blog">Blog & Tips</a></li>
              <li><a href="/contact" className="mds-link" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-[#4A5D54]">
              <li><a href="/about" className="mds-link" data-testid="footer-link-about">About Us</a></li>
              <li><a href="/privacy" className="mds-link" data-testid="footer-link-privacy">Privacy Policy</a></li>
              <li><a href="/terms" className="mds-link" data-testid="footer-link-terms">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E5E3DB] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm text-[#7A8C84]">
          <p>© {new Date().getFullYear()} Matt's Daily Savers. Links on this site may be referral links — thanks for the support.</p>
          <p>Made with care in the UK.</p>
        </div>
      </div>
    </footer>
  );
}
